import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import axios from 'axios';
import { useRecipeStore } from '../store/recipeStore';

export function RecipeImportPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { addRecipe } = useRecipeStore();

  useEffect(() => {
    const url = searchParams.get('url');
    if (!url) {
      navigate('/recipes');
      return;
    }

    const importRecipe = async () => {
      setLoading(true);
      setError(null);

      try {
        const { data } = await axios.post(
          '/api/extract-recipe',
          { url },
          {
            headers: { 'Content-Type': 'application/json' },
            timeout: 30000
          }
        );

        await addRecipe(data);
        navigate('/recipes');
      } catch (err) {
        console.error('Failed to import recipe:', err);
        setError(
          err instanceof Error 
            ? err.message 
            : axios.isAxiosError(err) && err.response?.data?.error
              ? err.response.data.error
              : 'Failed to import recipe'
        );
      } finally {
        setLoading(false);
      }
    };

    importRecipe();
  }, [searchParams, addRecipe, navigate]);

  return (
    <div className="min-h-[400px] flex items-center justify-center">
      {loading ? (
        <div className="text-center">
          <Loader2 size={40} className="animate-spin text-blue-500 mx-auto mb-4" />
          <h2 className="text-xl font-semibold mb-2">Importing Recipe</h2>
          <p className="text-gray-600">Please wait while we process your recipe...</p>
        </div>
      ) : error ? (
        <div className="text-center">
          <div className="p-4 bg-red-50 border border-red-200 rounded-lg text-red-700 mb-4">
            {error}
          </div>
          <button
            onClick={() => navigate('/recipes')}
            className="text-blue-600 hover:text-blue-700"
          >
            Return to Recipes
          </button>
        </div>
      ) : null}
    </div>
  );
}